const config = {
  apiGateway: {
    REGION: 'ap-southeast-1',
    INTERNAL_API_URL: 'https://tg0kerjwma.execute-api.ap-southeast-1.amazonaws.com/prod',
    TARGET_API_URL: 'https://gxg8p7yyee.execute-api.ap-southeast-1.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.oceanagold.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.oceanagold.forwoodsafety.com'
  }
};

export default config;